import { createI18n } from 'vue-i18n'
import dayjs from 'dayjs'
import 'dayjs/locale/en'
import 'dayjs/locale/id'
import 'dayjs/locale/zh-cn'
import id from '../locales/id/id.json'
import en from '../locales/en/en.json'
import zh from '../locales/zh/zh.json'

function setDayjsLanguage(lang: string) {
  if (lang === 'zh') {
    dayjs.locale('zh-cn')
    return
  }
  dayjs.locale(lang === 'id' ? 'id' : 'en')
}

const messages = {
  id,
  en,
  zh
}

const savedLang = localStorage.getItem('lang') || 'en'

document.documentElement.setAttribute('lang', savedLang)
setDayjsLanguage(savedLang)

const i18n = createI18n({
  legacy: false,
  locale: savedLang,
  fallbackLocale: 'en',
  messages
})

export function setLanguage(lang: string) {
  i18n.global.locale.value = lang as 'id' | 'en' | 'zh'
  setDayjsLanguage(lang)
  localStorage.setItem('lang', lang)
  document.documentElement.setAttribute('lang', lang)
}

export const supportedLocales = [
  { value: 'id', label: 'Bahasa Indonesia' },
  { value: 'en', label: 'English' },
  { value: 'zh', label: '中文' }
]

export default i18n
